import { LinksKeysProvider } from './useLinksKeys';
import { LinksListingProvider } from './useLinksListing';
import { LinksStateProvider } from './useLinksState';

export * from './interface';
export * from './link';
export { default as useLink } from './useLink';
export { default as useLinksActions } from './useLinksActions';
export { useLinksListing } from './useLinksListing';

export function LinksProvider({ children }: { children: React.ReactNode }) {
    return (
        <LinksStateProvider>
            <LinksKeysProvider>
                <LinksListingProvider>{children}</LinksListingProvider>
            </LinksKeysProvider>
        </LinksStateProvider>
    );
}
